import { css } from "@emotion/core";
import { color, fonts, fontSizes } from "theme/Theme";

const layoutStyles = css({
    height: "100vh",
    ".sider": {
      boxShadow: `0.25rem 0 0.625rem 0 ${color.boxShadow}`
    },
    "aside,footer,.ant-layout-footer,.ant-layout-sider":{
      opacity:0,
      visibility:'hidden'
    },
    ".mt-18":{
      marginTop: "18px"
    },
    ".mb-18":{
      marginBottom: "18px"
    },
    ".mb-12":{
      marginBottom: "12px"
    },
    ".sidebar-details": {
      fontFamily: fonts.bold,
      ".ant-typography": {
        color: color.bold
      }
    },
    ".error": {
      color: color.red,
      textAlign: "right",
      fontSize: fontSizes.error
    },
    ".sidebar-data-item": {
      textAlign: "center"
    },
    ".links": {
      ".ant-typography": {
        color: color.light
      }
    },
    ".link-item": {
      width: "100%",
      height: "100%",
      borderRadius: "0 2rem 2rem 0",
      "&:hover, &:focus, &:active": {
        backgroundColor: color.activeBackground
      },
      button: {
        padding: 0
      }
    },
    ".ellipsis": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      maxWidth: 150 //since sider is 200
    },
    ".logout-item": {
      marginTop: "auto",
      height: "auto"
    },
    ".selected-link-item": {
      backgroundColor: color.activeBackground,
      fontFamily: fonts.bold,
      ".ant-typography": {
        color: color.primary
      }
    },
    ".ant-layout-sider-zero-width-trigger": {
      // For a responsive Sider trigger.
      border: `solid 1px ${color.border}`
    },
    ".ant-layout-sider-children": {
      display: "flex",
      flexDirection: "column"
    },
    ".logout-overlay": {
      zIndex: 1,
      backgroundColor: color.primary,
      color: color.white,
      span: {
        color: color.white
      },
      "&:hover, &:focus, &:active": {
        backgroundColor: color.primary
      }
    },
  });

export default layoutStyles;